module.exports = __webpack_public_path__ + "523a19f5b0058eb0cbd299fa3aa9b604.mp4";